import { render, staticRenderFns } from "./SaldosPeriodo.vue?vue&type=template&id=2a76d926&"
import script from "./SaldosPeriodo.vue?vue&type=script&lang=js&"
export * from "./SaldosPeriodo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports